import Api from '../_redux/actions/api/_base';
import cookie from 'react-cookies';

export const handleAdyenSubmit = async (orderId, adyenData) => {
	const token = cookie.load('token');

	const terminal = adyenData.terminal;

	const paymentMethods = {
		paymentMethodCredit: 'credit_card',
		paymentMethodDebit: 'debit_card',
		paymentMethodPix: 'pix'
	};

	let paymentMethod = null;
	
	for (const [key, value] of Object.entries(paymentMethods)) {
		if (adyenData[key]) {
			paymentMethod = value;
			break;
		}
	}
	
	const installments =
		paymentMethod === 'credit_card' ? Number(adyenData.numberOfInstallment) : 1;

	const data = {
		orderId,
		paymentMethod,
		installments,
		terminal
	};
	const response = await Api.post('/adyen/payments', data, token);
	return response.data;
};

export const checkCreditAdyen = async orderId => {
	const token = cookie.load('token');

	const response = await Api.get(`/adyen/payments/update/${orderId}`, token);
	return response;
};
